/* Tidel: shipping-cutoff messaging. Not part of Ella.

   ONE script for the whole site and the single source of truth for the cutoff —
   used by the product cards and by the product page buy box.

   Cutoff: 16:00 America/New_York on a business day.
     before cutoff, Mon-Fri -> "Free Same-Day Shipping — ships today"
     otherwise               -> "Ships <next business day>"

   Two element flavours:
     [data-tidel-shipping]            static line (product cards)
     [data-tidel-shipping-countdown]  same, but before the cutoff it counts down
                                      "order within Xh Ym, ships today" and
                                      re-renders every 30s (product page)

   New York time is read via Intl with timeZone: 'America/New_York', so DST comes
   from the browser's tz database rather than a hardcoded offset. The shopper's
   own clock and locale are irrelevant. */
(function () {
  'use strict';

  var TZ = 'America/New_York';
  var CUTOFF_HOUR = 16;   /* 4 PM ET — the single source of truth */
  var STATIC = '[data-tidel-shipping]';
  var COUNTDOWN = '[data-tidel-shipping-countdown]';
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  /* The lead phrase is wrapped so the product page can colour it separately
     from the countdown. Product cards leave the span unstyled, so the markup
     is identical for both consumers. */
  var LEAD = '<span class="tidel-ship__lead">Free Same-Day Shipping</span>';

  /* Weekday index (0=Sun), hour and minute as they are in New York right now. */
  function newYorkNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TZ,
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
      }).formatToParts(new Date());

      var weekday = '';
      var hour = null;
      var minute = null;
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'weekday') weekday = parts[i].value;
        if (parts[i].type === 'hour') hour = parseInt(parts[i].value, 10);
        if (parts[i].type === 'minute') minute = parseInt(parts[i].value, 10);
      }
      var short = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var day = short.indexOf(weekday);
      if (day < 0 || hour === null || isNaN(hour) || minute === null || isNaN(minute)) return null;
      if (hour === 24) hour = 0; // some engines render midnight as 24
      return { day: day, hour: hour, minute: minute };
    } catch (e) {
      return null; // no Intl / no tz data -> leave the line hidden
    }
  }

  function isBusinessDay(day) {
    return day >= 1 && day <= 5;
  }

  function nextBusinessDay(day) {
    var d = day;
    do {
      d = (d + 1) % 7;
    } while (!isBusinessDay(d));
    return d;
  }

  function beforeCutoff(now) {
    return isBusinessDay(now.day) && now.hour < CUTOFF_HOUR;
  }

  function staticMessage(now) {
    if (beforeCutoff(now)) return LEAD + ' — ships <strong>today</strong>';
    return 'Ships <strong>' + DAYS[nextBusinessDay(now.day)] + '</strong>';
  }

  function countdownMessage(now) {
    if (!beforeCutoff(now)) {
      return 'Ships <strong>' + DAYS[nextBusinessDay(now.day)] + '</strong>';
    }
    var left = CUTOFF_HOUR * 60 - (now.hour * 60 + now.minute);
    var h = Math.floor(left / 60);
    var m = left % 60;
    var span = h > 0 ? h + 'h ' + m + 'm' : m + 'm';
    return LEAD + ' — order within <strong>' + span + '</strong>, ships today';
  }

  function paint() {
    var now = newYorkNow();
    if (!now) return; // unsupported environment: elements stay hidden

    var i;
    var statics = document.querySelectorAll(STATIC + ':not([data-tidel-filled])');
    var text = staticMessage(now);
    for (i = 0; i < statics.length; i++) {
      statics[i].innerHTML = text;
      statics[i].setAttribute('data-tidel-filled', '');
      statics[i].hidden = false;
    }

    // Countdown elements re-render on every tick, so they are not marked filled.
    var counters = document.querySelectorAll(COUNTDOWN);
    var counterText = countdownMessage(now);
    for (i = 0; i < counters.length; i++) {
      counters[i].innerHTML = counterText;
      counters[i].hidden = false;
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = window.setTimeout(function () {
      pending = null;
      paint();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint, { once: true });
  } else {
    paint();
  }

  /* Keep the countdown honest without hammering the page. */
  window.setInterval(paint, 30000);

  /* Cards arrive later too: theme-editor section reloads, and Ella's tabbed
     slider which hydrates hidden tabs from a <template> on first click. */
  document.addEventListener('shopify:section:load', schedule);

  if (typeof MutationObserver === 'function') {
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  window.tidelShipping = { refresh: paint };
})();
